<template>
  <div class="header">
    <div class="top-bg">
      <div class="top">
        <div class="top-l">
          <div class="logo">
            <a href="/" target="_blank">
              <img src="/Public/home/images/wkcsLOGO.png" />
            </a>
          </div>
        </div>
        <div class="top-r">
          <el-link
            type="info"
            :underline="false"
            href="http://www.100ec.cn/"
            target="_blank"
          >
            首页</el-link
          >

          <el-link
            type="info"
            :underline="false"
            href="http://www.100ec.cn/enterprise/"
            target="_blank"
          >
            公司</el-link
          >

          <el-link
            type="info"
            :underline="false"
            href="http://www.100ec.cn/Index/dsb_product.html"
            target="_blank"
          >
            数据</el-link
          >

          <el-link
            type="info"
            :underline="false"
            href="http://www.100ec.cn/Index/complain.html"
            target="_blank"
          >
            投诉</el-link
          >

          <el-link
            type="info"
            :underline="false"
            href="http://www.100ec.cn/Index/finance.html"
            target="_blank"
          >
            融资</el-link
          >

          <el-link
            type="info"
            :underline="false"
            href="http://www.100ec.cn/Index/needs.html"
            target="_blank"
          >
            战疫</el-link
          >

          <el-link
            type="info"
            :underline="false"
            href="http://www.100ec.cn/dh.html"
            target="_blank"
          >
            导航</el-link
          >
        </div>
      </div>
    </div>

    <div class="search-bg">
      <h1>网课超市</h1>

      <div class="search">
        <el-input
          class="input-with-select"
          style="height: 100%"
          placeholder="请输入平台名"
          v-model="keywords"
          @keyup.enter.native="getSearch()"
        ></el-input>

        <div class="search-btn">
          <i class="el-icon-search" @click="getSearch()"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      keywords: "",
    };
  },
  methods: {
    getSearch() {
      if (this.keywords != "") {
        window.open("/enterprise/#/Inside?name=" + this.keywords);
      } else {
        this.$message({
          showClose: true,
          message: "请输入平台名！",
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 20px;
}

.top-bg {
  width: 100%;
  background: #fff;
  border-bottom: #eee solid 1px;
  box-shadow: 0px 0px 9.5px 0.5px rgb(49 87 163 / 13%);
  padding: 10px 0;
}
.top {
  max-width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}
.top .el-link {
  line-height: 40px;
  padding: 0 15px;
}
.logo img {
  height: 40px;
}

.search-bg {
  width: 100%;
  margin: auto;
  padding: 100px 0;
  background: url("../assets/banner.jpg") no-repeat bottom;
}

.search-bg h1 {
  font-size: 40px;
  color: #fff;
  text-align: center;
  letter-spacing: 5px;
}
.search {
  max-width: 400px;
  margin: 40px auto;
  position: relative;
}
/* .search .el-input-group {
    height: 55px;
} */

.search-btn {
  width: 40px;
  height: 100%;
  text-align: center;
  line-height: 40px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  position: absolute;
  top: calc(50% - 20px);
  right: 0;
  transition: all 0.3s ease-in-out;
}

.search i {
  color: #ccc;
  transition: all 0.3s ease-in-out;
}

.search-btn:hover i {
  color: #fff;
}
@media (max-width: 1100px) {
  .top-r .el-link {
    padding: 0 2px;
  }
  .search-bg {
    height: 80px;
    padding: 60px 0;
  }
  .search-bg h1 {
    font-size: 30px;
  }
  .search {
    max-width: 320px;
    margin: 30px auto;
  }
}
</style>